/**
 * @desc 获取管理域中工序层
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 组织编码 */
  orgCode?: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryBaseInfoListResponse>> {
  return defHttp.get({
    url: '/web/base/process',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryBaseInfoListResponse>> {
  return defHttp.get({
    url: '/mock/web/base/process',

    params,
  });
}
